export enum TemplateType {
    Document = 1,
}
